// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Core__Int = require("@rescript/core/src/Core__Int.res.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Radio = require("@mui/material/Radio").default;
var Select = require("@mui/material/Select").default;
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var InputLabel = require("@mui/material/InputLabel").default;
var RadioGroup = require("@mui/material/RadioGroup").default;
var FormControl = require("@mui/material/FormControl").default;
var MM_bottom_up_prover_params = require("../mm-utils/MM_bottom_up_prover_params.res.js");
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function validate(values) {
  var values$1 = values.searchDepth < 1 || 10000 < values.searchDepth ? ({
        searchDepth: 1,
        lengthRestrict: values.lengthRestrict,
        allowNewDisjForExistingVars: values.allowNewDisjForExistingVars,
        allowNewStmts: values.allowNewStmts,
        allowNewVars: values.allowNewVars,
        debugLevel: values.debugLevel
      }) : values;
  var match = MM_bottom_up_prover_params.lengthRestrictFromStr(values$1.lengthRestrict);
  var values$2 = match !== undefined ? values$1 : ({
        searchDepth: values$1.searchDepth,
        lengthRestrict: MM_bottom_up_prover_params.lengthRestrictToStr("Less"),
        allowNewDisjForExistingVars: values$1.allowNewDisjForExistingVars,
        allowNewStmts: values$1.allowNewStmts,
        allowNewVars: values$1.allowNewVars,
        debugLevel: values$1.debugLevel
      });
  if (values$2.debugLevel < 0 || 1 < values$2.debugLevel) {
    return {
            searchDepth: values$2.searchDepth,
            lengthRestrict: values$2.lengthRestrict,
            allowNewDisjForExistingVars: values$2.allowNewDisjForExistingVars,
            allowNewStmts: values$2.allowNewStmts,
            allowNewVars: values$2.allowNewVars,
            debugLevel: 0
          };
  } else {
    return values$2;
  }
}

function setSearchDepth(values, newVal) {
  return {
          searchDepth: newVal,
          lengthRestrict: values.lengthRestrict,
          allowNewDisjForExistingVars: values.allowNewDisjForExistingVars,
          allowNewStmts: values.allowNewStmts,
          allowNewVars: values.allowNewVars,
          debugLevel: values.debugLevel
        };
}

function setLengthRestrict(values, newVal) {
  return {
          searchDepth: values.searchDepth,
          lengthRestrict: newVal,
          allowNewDisjForExistingVars: values.allowNewDisjForExistingVars,
          allowNewStmts: values.allowNewStmts,
          allowNewVars: values.allowNewVars,
          debugLevel: values.debugLevel
        };
}

function setAllowNewDisjForExistingVars(values, newVal) {
  return {
          searchDepth: values.searchDepth,
          lengthRestrict: values.lengthRestrict,
          allowNewDisjForExistingVars: newVal,
          allowNewStmts: values.allowNewStmts,
          allowNewVars: values.allowNewVars,
          debugLevel: values.debugLevel
        };
}

function setAllowNewStmts(values, newVal) {
  return {
          searchDepth: values.searchDepth,
          lengthRestrict: values.lengthRestrict,
          allowNewDisjForExistingVars: values.allowNewDisjForExistingVars,
          allowNewStmts: newVal,
          allowNewVars: values.allowNewVars,
          debugLevel: values.debugLevel
        };
}

function setAllowNewVars(values, newVal) {
  return {
          searchDepth: values.searchDepth,
          lengthRestrict: values.lengthRestrict,
          allowNewDisjForExistingVars: values.allowNewDisjForExistingVars,
          allowNewStmts: values.allowNewStmts,
          allowNewVars: newVal,
          debugLevel: values.debugLevel
        };
}

function setDebugLevel(values, newVal) {
  return {
          searchDepth: values.searchDepth,
          lengthRestrict: values.lengthRestrict,
          allowNewDisjForExistingVars: values.allowNewDisjForExistingVars,
          allowNewStmts: values.allowNewStmts,
          allowNewVars: values.allowNewVars,
          debugLevel: newVal
        };
}

function MM_cmp_bottom_up_prover_settings(props) {
  var onChange = props.onChange;
  var settings = props.settings;
  var match = React.useState(function () {
        return "";
      });
  var setSearchDepthStrPriv = match[1];
  var searchDepthStr = match[0];
  React.useEffect((function () {
          setSearchDepthStrPriv(function (param) {
                return settings.searchDepth.toString();
              });
        }), [settings.searchDepth]);
  var updateSettings = function (update) {
    onChange(validate(update(settings)));
  };
  var setSearchDepthStr = function (newSearchDepthStr) {
    setSearchDepthStrPriv(function (param) {
          return newSearchDepthStr;
        });
    var searchDepth = Core__Int.fromString(newSearchDepthStr, undefined);
    if (searchDepth !== undefined) {
      return updateSettings(function (__x) {
                  return setSearchDepth(__x, searchDepth);
                });
    }
    
  };
  var rndLengthRestrictSelector = function (value) {
    return React.createElement(FormControl, {
                size: "small",
                children: Caml_option.some(null)
              }, React.createElement(InputLabel, {
                    id: "length-restrict-select-label",
                    children: "Statement length restriction"
                  }), React.createElement(Select, {
                    sx: {
                      width: 190
                    },
                    labelId: "length-restrict-select-label",
                    label: "Statement length restriction",
                    value: value,
                    onChange: Expln_React_common.evt2str(function (str) {
                          updateSettings(function (__x) {
                                return setLengthRestrict(__x, str);
                              });
                        }),
                    children: Caml_option.some(null)
                  }, React.createElement(MenuItem, {
                        value: "No",
                        children: "Unrestricted"
                      }), React.createElement(MenuItem, {
                        value: "LessEq",
                        children: "LessEq"
                      }), React.createElement(MenuItem, {
                        value: "Less",
                        children: "Less"
                      })));
  };
  var rndDebugParam = function (debugLevel) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "center",
                children: Caml_option.some(null)
              }, "Logging level", React.createElement(RadioGroup, {
                    value: String(debugLevel),
                    onChange: Expln_React_common.evt2str(function (str) {
                          updateSettings(function (__x) {
                                return setDebugLevel(__x, Core__Option.getOr(Core__Int.fromString(str, undefined), 0));
                              });
                        }),
                    row: true,
                    children: Caml_option.some(null)
                  }, React.createElement(FormControlLabel, {
                        control: React.createElement(Radio, {}),
                        label: "0",
                        value: "0"
                      }), React.createElement(FormControlLabel, {
                        control: React.createElement(Radio, {}),
                        label: "1",
                        value: "1"
                      })));
  };
  var rndParams = function () {
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, React.createElement(Expln_React_Row.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(TextField, {
                        value: searchDepthStr,
                        label: "Search depth",
                        size: "small",
                        style: {
                          width: "100px"
                        },
                        onChange: Expln_React_common.evt2str(setSearchDepthStr),
                        autoFocus: true
                      }), rndLengthRestrictSelector(settings.lengthRestrict)), React.createElement(Expln_React_Row.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(FormControlLabel, {
                        control: React.createElement(Checkbox, {
                              checked: settings.allowNewDisjForExistingVars,
                              onChange: Expln_React_common.evt2bool(function (b) {
                                    updateSettings(function (__x) {
                                          return setAllowNewDisjForExistingVars(__x, b);
                                        });
                                  })
                            }),
                        label: "Allow new disjoints",
                        style: {
                          border: "solid 1px lightgrey",
                          marginTop: "-2px",
                          marginLeft: "2px",
                          paddingRight: "10px",
                          borderRadius: "7px"
                        }
                      }), React.createElement(FormControlLabel, {
                        control: React.createElement(Checkbox, {
                              checked: settings.allowNewStmts,
                              onChange: Expln_React_common.evt2bool(function (b) {
                                    updateSettings(function (__x) {
                                          return setAllowNewStmts(__x, b);
                                        });
                                  })
                            }),
                        label: "Allow new steps",
                        style: {
                          border: "solid 1px lightgrey",
                          marginTop: "-2px",
                          marginLeft: "2px",
                          paddingRight: "10px",
                          borderRadius: "7px"
                        }
                      }), React.createElement(FormControlLabel, {
                        control: React.createElement(Checkbox, {
                              checked: settings.allowNewVars,
                              onChange: Expln_React_common.evt2bool(function (b) {
                                    updateSettings(function (__x) {
                                          return setAllowNewVars(__x, b);
                                        });
                                  })
                            }),
                        label: "Allow new variables",
                        disabled: !settings.allowNewStmts,
                        style: {
                          border: "solid 1px lightgrey",
                          marginTop: "-2px",
                          paddingRight: "10px",
                          borderRadius: "7px"
                        }
                      })), React.createElement(Expln_React_Row.make, {
                    children: Caml_option.some(rndDebugParam(settings.debugLevel))
                  }));
  };
  return rndParams();
}

var make = MM_cmp_bottom_up_prover_settings;

exports.validate = validate;
exports.setSearchDepth = setSearchDepth;
exports.setLengthRestrict = setLengthRestrict;
exports.setAllowNewDisjForExistingVars = setAllowNewDisjForExistingVars;
exports.setAllowNewStmts = setAllowNewStmts;
exports.setAllowNewVars = setAllowNewVars;
exports.setDebugLevel = setDebugLevel;
exports.make = make;
/* react Not a pure module */
